module.exports = __webpack_public_path__ + "static/106_home-0f0d311fba4a8937d9519ead140ceb94.png";